import { ResourceSearchService } from '@/services/resource-search-service';
import { ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
const service = new ResourceSearchService();
export default {
    name: 'SearchBar',
    setup() {
        const router = useRouter();
        const store = useStore();
        const searchText = ref(null);
        function search() {
            store.dispatch('Resources/SubmitTextOnlyRequest', searchText.value);
            router.push('/Resources');
        }
        return { searchText, search };
    },
};
